import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonBeatsDialogComponent } from 'src/app/components/shared/popups/common-beat-popups/common-beats-dialog.component';
import { FilterBeatComponent } from 'src/app/components/shared/popups/common-beat-popups/filter-beat/filter-beat.component';
import { PriceComponent } from 'src/app/components/shared/popups/common-beat-popups/price/price.component';
import { ShareBeatComponent } from 'src/app/components/shared/popups/common-beat-popups/share-beat/share-beat.component';
import { DownloadBeatComponent } from 'src/app/components/shared/popups/common-beat-popups/download-beat/download-beat.component';
import { MaterialModule } from 'src/app/material/material';
import { PrimeMaterialModule } from '../ng-prime/prime-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { GetFilterKeysNamePipe } from 'src/app/pipes/get-filter-keys-name/get-filter-keys-name.pipe';
import { GetSubscriptionTiresPipe } from 'src/app/pipes/get-subs-tires/get-subs-tires.pipe';
import { CheckExclusiveLic } from 'src/app/pipes/check-exclusive/check-exclusive-exist.pipe';
import { FilterListSeprationPipe } from 'src/app/pipes/filter-list/filter-list-sepration.pipe';
import { MsFilterSearchPipe } from 'src/app/pipes/ms-filter-search/ms-filter-search.pipe';
import { MagicSearchStemEqComponent } from 'src/app/components/shared/magic-search/magic-search-stem-eq/magic-search-stem-eq.component';
import { CreditPopupComponent } from 'src/app/components/shared/popups/credit-popup/credit-popup.component';
import { PaymentSuccessComponent } from 'src/app/components/shared/payment-success/payment-success.component';
import { LottieModule } from 'ngx-lottie';
import { playerFactory } from '../shared-module/lottie-player.factory';
import { LyricsEditorComponent } from 'src/app/components/shared/popups/lyrics-editor/lyrics-editor.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { LicenseAgreementComponent } from 'src/app/components/shared/license-agreement/license-agreement.component';
import { LicenseExclusiveComponent } from 'src/app/components/shared/license-agreement/license-exculsive/license-exclusive.component';
import { LicenseWavComponent } from 'src/app/components/shared/license-agreement/license-wav/license-wav.component';
import { LicenseWavStemsComponent } from 'src/app/components/shared/license-agreement/license-wav-stems/license-wav-stems.component';
import { LicenseWavSoundComponent } from 'src/app/components/shared/license-agreement/license-wav-sound/license-wav-sound.component';
import { Mp3LicenseComponent } from 'src/app/components/shared/license-agreement/mp3-license/mp3-license.component';
import { FireworksDirective } from 'src/app/directives/fireworks.directive';


const components = [
  CommonBeatsDialogComponent,
  FilterBeatComponent,
  PriceComponent,
  ShareBeatComponent,
  DownloadBeatComponent,
  CreditPopupComponent,
  PaymentSuccessComponent,
  LyricsEditorComponent,
  LicenseAgreementComponent,
  LicenseExclusiveComponent,
  LicenseWavComponent,
  LicenseWavStemsComponent,
  LicenseWavSoundComponent,
  Mp3LicenseComponent,
  MagicSearchStemEqComponent
]

@NgModule({
    declarations: [
        ...components,
        GetFilterKeysNamePipe,
        GetSubscriptionTiresPipe,
        FilterListSeprationPipe,
        CheckExclusiveLic,
        MsFilterSearchPipe
    ],
    exports: [
        ...components,
        GetFilterKeysNamePipe,
        GetSubscriptionTiresPipe,
        FilterListSeprationPipe,
        CheckExclusiveLic,
        MsFilterSearchPipe
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    imports: [
        CommonModule,
        MaterialModule,
        PrimeMaterialModule,
        ReactiveFormsModule,
        FormsModule,
        ShareButtonsModule,
        ShareIconsModule,
        NgxSpinnerModule,
        FontAwesomeModule,
        LottieModule.forRoot({ player: playerFactory }),
        CarouselModule,
        FireworksDirective,
    ]
})
export class CommonBeatsDialogModule { }
